/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { EnableSidebar, PageTitle } from '../../../../_metronic/layout/core'
import { Questions } from '../dev/components/partials/Questions'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import {KTSVG} from '../../../../_metronic/helpers'

const AboutUs: FC = () => {
  // const intl = useIntl()
  return (
    <EnableSidebar>
      <PageTitle description='You’ve got 24 New Sales' breadcrumbs={[]}>
        Hello, Paul
      </PageTitle>

      <div className='card card-custom overlay min-h-300px mb-5 shadow-none'>
        <div className='card-body d-flex flex-column p-0'>
          <div
            className='overlay-wrapper flex-grow-1 bgi-no-repeat bgi-size-cover bgi-position-center'
            style={{
              backgroundImage: `url('${toAbsoluteUrl(
                '/media/logos/aboutus2.jpg'
              )}')`,
            }}
          />
          {/*<div className='overlay-layer bg-body bg-opacity-50'>
            <a href='#' className='btn btn-sm fw-bold btn-primary'>
              Explore
            </a>
          </div>*/}
        </div>
      </div>

      <div className='card mb-10'>
        <div className='card-body d-flex align-items-center py-8'>
          {/* begin::Icon */}
          <div className='d-flex h-80px w-80px flex-shrink-0 flex-center position-relative'>
            <KTSVG
              path='/media/icons/duotune/abstract/abs051.svg'
              className='svg-icon-primary position-absolute opacity-15'
              svgClassName='h-80px w-80px'
            />
            <i className="bi bi-question-circle fs-2x"></i>
            {/*<KTSVG
              path='/media/icons/duotune/coding/cod009.svg'
              className='svg-icon-3x svg-icon-primary position-absolute'
            />*/}
          </div>
          {/* end::Icon */}

           {/* begin::Description */}
           <div className='ms-6'>
            <p className='list-unstyled text-gray-600 fs-6 p-0 m-0'>
            คลังปัญญาสถาบัน (Institutional Repository) คณะศิลปศาสตร์ มหาวิทยาลัยธรรมศาสตร์ เป็นคลังความรู้ที่เป็นแหล่งรวบรวม
            เผยแพร่ และสงวนรักษาผลผลิตทางปัญญาของบุคลากรในองค์กรในรูปแบบดิจิทัล เข้าถึงได้แบบเสรี โดยได้รวบรวมความรู้ประเภทต่างๆ 
            ของคณะ เช่น รายงานวิจัย บทความวิจัย บทความวิชาการ เอกสารประกอบการประชุมวิชาการ คลิปการสัมมนาวิชาการ วิทยานิพนธ์ ภาคนิพนธ์ ฯลฯ
            โดยมีวัตถุประสงค์เพื่อเผยแพร่ความรู้ของคณะศิลปศาสตร์แก่นักวิชาการและผู้สนใจทั่วไป ทั้งภายในและภายนอกองค์กรสามารถรับรู้
            เข้าถึงและใช้ประโยชน์ได้อย่างเสรีในระยะยาว และสามารถสืบค้นอ้างอิงได้
            </p>
          </div>
          {/* end::Description */}
        </div>
      </div>

      <h1 className='fs-2x fw-bolder text-gray-900 mb-5 me-1'>
            ติดต่อเรา
      </h1>

      <span className='fs-3'>
        คณะศิลปศาสตร์ มหาวิทยาลัยธรรมศาสตร์ (ท่าพระจันทร์)
      </span>
      <br/>
      <span className='fs-3'>
        คณะศิลปศาสตร์ มหาวิทยาลัยธรรมศาสตร์ (ท่าพระจันทร์)
        2 ถนนพระจันทร์ เขตพระนคร กทม.10200
      </span>
      <br/>
      <span className='fs-3'>
        โทรศัพท์: 0-2613-2646 / Fax: 0-2222-0869
        E-mail:pr@arts.tu.ac.th
      </span>

    </EnableSidebar>
  )
}

export { AboutUs }
